import { useAuth as useAuthContext } from '../../contexts/AuthContext';

export const useAuth = () => {
    const auth = useAuthContext();

    // Since permission system is skipped, always return true for checkPermission
    const checkPermission = (permissionKey) => {
        return true;
    };

    return { ...auth, checkPermission };
};

